import {utils} from "../utils";

export function googleAnalytics() {
	ga("create", window.tracker);
	ga("require", "ec");
	setUtmCookies();

	function setUtmCookies() {
		ga(function (tracker) {
			var client_id = tracker.get("clientId") || null;
			utils.setCookie("client_id", client_id, {path: "/", domain: window.domain});
		});

		if (
			(getUrlParam("utm_campaign") != null && getUrlParam("utm_campaign") != "") ||
			(getUrlParam("utm_source") != null && getUrlParam("utm_source") != "")
		) {
			if (
				getUrlParam("utm_campaign") != utils.getCookie("utm_campaign") ||
				getUrlParam("utm_source") != utils.getCookie("utm_source")
			) {
				utils.setCookie("utm_source", getUrlParam("utm_source"), {
					path: "/",
					domain: window.domain,
				});
				utils.setCookie("utm_campaign", getUrlParam("utm_campaign"), {
					path: "/",
					domain: window.domain,
				});
				utils.setCookie("utm_medium", getUrlParam("utm_medium"), {
					path: "/",
					domain: window.domain,
				});
				utils.setCookie("utm_term", getUrlParam("utm_term"), {
					path: "/",
					domain: window.domain,
				});
				utils.setCookie("utm_content", getUrlParam("utm_content"), {
					path: "/",
					domain: window.domain,
				});
			}
		}
	}

	function getUrlParam(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
}
